import React from 'react'
import styled from 'styled-components'
import { withAuthProvider } from '../../lib/auth'
import { Footer, footerOptions, optionsFor } from '@pga/pga-component-library'

const FooterContainer = styled.div`
  text-align: left;
`

export const FooterComponent = ({ isLoggedIn, me }) =>
  <FooterContainer>
    <Footer
      sections={optionsFor(me)}
      copyright={footerOptions.copyrightMessage}
    />
  </FooterContainer>

export default withAuthProvider(FooterComponent)
